import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 flex items-center justify-center py-20">
        <div className="text-center px-4">
          <div className="w-24 h-24 mx-auto mb-6 flex items-center justify-center rounded-full bg-primary-100">
            <i className="ri-emotion-sad-line text-4xl text-primary-500"></i>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-900 mb-3">404</h1>
          <p className="text-base text-foreground-500 mb-8">抱歉，您访问的页面不存在</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer"
          >
            <i className="ri-home-line"></i> 返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}